<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editSalesChannelForm" (ngSubmit)="submit()">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.CanalVenta || 'Canal de venta' }}</mat-label>
            <input
              matInput
              formControlName="CanalVenta"
              maxlength="50"
              (input)="onInputForbiddenSequences($event, 'CanalVenta')"
            />
            <mat-error *ngIf="validateFields('CanalVenta')">
              {{ getErrorMessage("CanalVenta") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.Organizacion || 'Organización' }}</mat-label>
            <input
              matInput
              formControlName="Organizacion"
              maxlength="50"
              (input)="onInputForbiddenSequences($event, 'Organizacion')"
            />
            <mat-error *ngIf="validateFields('Organizacion')">
              {{ getErrorMessage("Organizacion") }}
            </mat-error>
          </mat-form-field>

          <div class="toggle-wrap">
            <label>{{ translation?.Activo || "Activo" }}</label>
            <mat-slide-toggle formControlName="Activo"></mat-slide-toggle>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
